import { type FieldType, isEnumType, isObjectType } from '../../../store/types';
import { newProperty, padEnumValues } from '../../../store/utils';
import type { SchemaEditorState, SchemaPatch } from '../../../store/wire';

export const getSchemaPatchForTypeChange = (
  schema: SchemaEditorState,
  nextType: FieldType,
): { patch: SchemaPatch; autoOpenEditor: boolean } => {
  const patch: SchemaPatch = { type: nextType };
  if (isEnumType(nextType)) {
    patch.enumValues = padEnumValues(schema.enumValues);
    return { patch, autoOpenEditor: true };
  }
  if (isObjectType(nextType)) {
    if (!schema.children || schema.children.length === 0) {
      patch.children = [newProperty()];
    }
    return { patch, autoOpenEditor: true };
  }
  return { patch, autoOpenEditor: false };
};
